import Vue from 'vue';
import VueRouter from 'vue-router';
import {
  SPECIALIST_CLINIC,
  SPECIALIST_DETAIL,
  DOCTOR_SEARCH,
  GROUP_DOCTOR_LIST,
  CLINIC_PAYMENT,
  FAST_INQUIRY,
  FOLLOWED_SPECIALIST,
  DEPARTMENT_SEARCH,
  CHANGE_SPECIALIST_DETAIL,
  RECOMMEND_SPECIALIST,
  HOSPITAL_LIST,
  HOSPITAL_INTRO,
  HOSPITAL_DETAIL,
  DEPARTMENT_SPECIALIST,
  PAGE_EXPERT_CONSULTATION,
  PAGE_EXPERT_CONSULTATION_PAY,
  PAGE_EXPERT_CONSULTATION_HOSPITAL,
  PAGE_EXPERT_CONSULTATION_SEARCH_RESULT,
  PAGE_EXPERT_CONSULTATION_HOSPITAL_DETAILS,
  PAGE_EXPERT_CONSULTATION_HOSPITAL_INTRODUCTION,
  PAGE_EXPERT_CONSULTATION_DEPARTMENT_DOCTOR_RESULTS,
  PAGE_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_RESULTS,
  CLICK_EXPERT_CONSULTATION_AREA,
  CLICK_EXPERT_CONSULTATION_FILTER,
  CLICK_EXPERT_CONSULTATION_AREA_SELECT,
  CLICK_EXPERT_CONSULTATION_DEPARTMENT_SELECT,
  CLICK_EXPERT_CONSULTATION_FILTER_RESET,
  CLICK_EXPERT_CONSULTATION_FILTER_DETERMINE,
  PAY,
  PAY_SUCCESS,
  PAY_FAIL,
  CLICK_EXPERT_CONSULTATION_DEPARTMENT,
  CLICK_EXPERT_CONSULTATION_FILTER_ITEM,
  CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_TYPE_SELECT,
  CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_AREA_SELECT,
  ZYJK_PAGE_QUICKINQUIRY_PAY,
  ROUTE_PATH
} from '@/constant';
import { FILTER_TELESCOPE_ENUM } from '@/pages/DoctorSearch/SearchFilter';

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: SPECIALIST_CLINIC,
      name: SPECIALIST_CLINIC,
      component: () => import('@/pages/SpecialistClinic/index.vue'),
      meta: {
        title: '专家问诊',
        telescope: PAGE_EXPERT_CONSULTATION
      }
    },
    {
      path: `${CHANGE_SPECIALIST_DETAIL}/:id`,
      name: CHANGE_SPECIALIST_DETAIL,
      component: () => import('@/pages/SpecialistDetail/index.vue'),
      meta: {
        title: '更换医生'
      }
    },
    {
      path: `${SPECIALIST_DETAIL}/:id`,
      name: SPECIALIST_DETAIL,
      component: () => import('@/pages/SpecialistDetail/index.vue'),
      meta: {
        title: '医生主页'
      }
    },
    {
      path: `${CLINIC_PAYMENT}/:id`,
      name: CLINIC_PAYMENT,
      component: () => import('@/pages/ClinicPayment/index.vue'),
      meta: {
        title: '支付',
        authorization: true,
        telescope: PAGE_EXPERT_CONSULTATION_PAY
      }
    },
    {
      path: `${FAST_INQUIRY}/:consultId`,
      name: FAST_INQUIRY,
      component: () => import('@/pages/ClinicPayment/fastInquiryPay.vue'),
      meta: {
        title: '支付',
        authorization: true,
        telescope: ZYJK_PAGE_QUICKINQUIRY_PAY
      }
    },
    // {
    //   path: `${PAY}`,
    //   name: PAY,
    //   component: () => import('@/pages/ClinicPayment/Pay.vue'),
    //   meta: {
    //     title: '支付',
    //     authorization: true
    //   }
    // },
    {
      path: `${PAY_SUCCESS}`,
      name: PAY_SUCCESS,
      component: () => import('@/pages/ClinicPayment/PaySuccess.vue'),
      meta: {
        title: '支付成功',
        authorization: true
      }
    },
    {
      path: `${PAY_FAIL}`,
      name: PAY_FAIL,
      component: () => import('@/pages/ClinicPayment/PayFail.vue'),
      meta: {
        title: '支付失败',
        authorization: true
      }
    },
    {
      path: `${GROUP_DOCTOR_LIST}/:type`,
      name: GROUP_DOCTOR_LIST,
      component: () => import('@/pages/DoctorSearch/groupDoctorList.vue'),
      meta: {
        title: '华医医生'
      }
    },
    {
      path: DOCTOR_SEARCH,
      name: DOCTOR_SEARCH,
      component: () => import('@/pages/DoctorSearch/index.vue'),
      meta: {
        title: '搜索',
        telescope: PAGE_EXPERT_CONSULTATION_SEARCH_RESULT,
        telescopeMap: {
          [FILTER_TELESCOPE_ENUM.DEPARTMENT]: CLICK_EXPERT_CONSULTATION_DEPARTMENT,
          [FILTER_TELESCOPE_ENUM.CITY]: CLICK_EXPERT_CONSULTATION_AREA,
          [FILTER_TELESCOPE_ENUM.CONDITION]: CLICK_EXPERT_CONSULTATION_FILTER,
          [FILTER_TELESCOPE_ENUM.SELECT_CITY]: CLICK_EXPERT_CONSULTATION_AREA_SELECT,
          [FILTER_TELESCOPE_ENUM.SELECT_DEPARTMENT]: CLICK_EXPERT_CONSULTATION_DEPARTMENT_SELECT,
          [FILTER_TELESCOPE_ENUM.SELECT_CONDITION]: CLICK_EXPERT_CONSULTATION_FILTER_ITEM,
          [FILTER_TELESCOPE_ENUM.CONDITION_RESET]: CLICK_EXPERT_CONSULTATION_FILTER_RESET,
          [FILTER_TELESCOPE_ENUM.CONDITION_CONFIRM]: CLICK_EXPERT_CONSULTATION_FILTER_DETERMINE
        }
      }
    },
    {
      path: `${DEPARTMENT_SEARCH}/:id?`,
      name: DEPARTMENT_SEARCH,
      component: () => import('@/pages/DoctorSearch/index.vue'),
      meta: {
        title: '科室搜索',
        telescope: PAGE_EXPERT_CONSULTATION_DEPARTMENT_DOCTOR_RESULTS
      }
    },
    {
      path: FOLLOWED_SPECIALIST,
      name: FOLLOWED_SPECIALIST,
      component: () => import('@/pages/FollowedSpecialist/index.vue'),
      meta: {
        title: '我的医生',
        authorization: true
      }
    },
    {
      path: RECOMMEND_SPECIALIST,
      name: RECOMMEND_SPECIALIST,
      component: () => import('@/pages/FollowedSpecialist/index.vue'),
      meta: {
        title: '推荐医生',
        authorization: true
      }
    },

    {
      path: DEPARTMENT_SPECIALIST,
      name: DEPARTMENT_SPECIALIST,
      component: () => import('@/pages/FollowedSpecialist/index.vue'),
      meta: {
        authorization: true,
        telescope: PAGE_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_RESULTS
      }
    },
    {
      path: HOSPITAL_LIST,
      name: HOSPITAL_LIST,
      component: () => import('@/pages/HospitalList/index.vue'),
      meta: {
        title: '按医院找医生',
        authorization: true,
        telescope: PAGE_EXPERT_CONSULTATION_HOSPITAL,
        telescopeMap: {
          [FILTER_TELESCOPE_ENUM.CITY]: CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_AREA_SELECT,
          [FILTER_TELESCOPE_ENUM.HOSPITALS_TYPE]: CLICK_EXPERT_CONSULTATION_HOSPITAL_DOCTOR_TYPE_SELECT
        }
      }
    },
    {
      path: `${HOSPITAL_INTRO}/:id`,
      name: HOSPITAL_INTRO,
      component: () => import('@/pages/HospitalIntro/index.vue'),
      meta: {
        title: '医院简介',
        telescope: PAGE_EXPERT_CONSULTATION_HOSPITAL_INTRODUCTION
      }
    },
    {
      path: `${HOSPITAL_DETAIL}/:id`,
      name: HOSPITAL_DETAIL,
      component: () => import('@/pages/HospitalDetail/index.vue'),
      meta: {
        title: '医院详情页',
        telescope: PAGE_EXPERT_CONSULTATION_HOSPITAL_DETAILS
      }
    },
    {
      path: ROUTE_PATH.checkout,
      name: ROUTE_PATH.checkout,
      component: () => import('../pages/checkout/Checkout.vue'),
      meta: {
        title: '智云收银台',
        authorization: false,
        telescope: 'common-page-checkout-checkout'
      }
    },
    {
      path: ROUTE_PATH.confirm,
      name: ROUTE_PATH.confirm,
      component: () => import('../pages/checkout/CheckoutConfirm.vue'),
      meta: {
        title: '支付确认',
        authorization: false,
        telescope: 'common-page-checkout-confirm'
      }
    },
    {
      path: ROUTE_PATH.success,
      name: ROUTE_PATH.success,
      component: () => import('../pages/checkout/CheckoutSuccess.vue'),
      meta: {
        title: '支付成功',
        authorization: false,
        telescope: 'common-page-checkout-success'
      }
    },
    {
      path: ROUTE_PATH.fail,
      name: ROUTE_PATH.fail,
      component: () => import('../pages/checkout/CheckoutFail.vue'),
      meta: {
        title: '支付失败',
        authorization: false,
        telescope: 'common-page-checkout-fail'
      }
    },
  ]
});
